/* Product card behaviour, extracted from snippets/product-card-new-home.liquid and
   product-card-home.liquid.

   It used to be emitted inline once per card. A product page rendered 31 byte identical
   copies, 184,636 bytes of duplicated HTML, downloaded and parsed every time. The script
   already carried an _yhlCardInit guard, so only the first copy ever ran; the other 30
   were pure weight.

   The code is unchanged. It contains no Liquid, which is why all copies were identical.

   BEHAVIOUR NOTE: the first inline copy executed mid parse, when only the first card
   existed, so the three immediate querySelectorAll loops, the delivery estimate loop and
   the two variant select loops, only ever saw that first card. Loaded with defer the DOM
   is complete, so they now see every card, which is what the loops were clearly written
   to do. Click and change handling was always delegated on document and is unaffected. */

(function () {
  if (window._yhlCardInit) return;
  window._yhlCardInit = true;

  /* ── Helpers ── */
  var R = '\u20B9';
  function fmt(cents)     { return R + '\u00A0' + Math.round(cents / 100).toLocaleString('en-IN'); }
  function fmtSave(cents) { return R + Math.round(cents / 100).toLocaleString('en-IN'); }
  function $q(card, sel)  { return card && card.querySelector(sel); }

  /* ── Pincode / Delivery ── */
  function showEstimate(pin) {
    if (!window.YHLPincode || !pin) return;
    window.YHLPincode.loadData().then(function(data) {
      var result = window.YHLPincode.getDeliveryText(pin, data);
      if (!result) return;
      document.querySelectorAll('[data-delivery-estimate]').forEach(function(el) {
        el.textContent = result.text;
        el.className = 'product-card__delivery-estimate' + (result.ok ? '' : ' is-error');
      });
    });
  }

  /* ── Variant image preload: idle-time staggered ── */
  function preloadVariantImages() {
    var srcs = [];
    document.querySelectorAll('.product-card__variant-select option[data-variant-image]').forEach(function (opt) {
      if (opt.dataset.variantImage) srcs.push(opt.dataset.variantImage);
    });
    var i = 0;
    function next() {
      if (i >= srcs.length) return;
      var p = new Image(); p.onload = p.onerror = next; p.src = srcs[i++];
    }
    var run = function () { next(); next(); next(); };
    if ('requestIdleCallback' in window) { requestIdleCallback(run, { timeout: 3000 }); }
    else { setTimeout(run, 2000); }
  }

  /* ── Image swap ── */
  function swapImage(card, pid, imgUrl) {
    if (!imgUrl) return;
    var img = $q(card, '[data-primary-image="' + pid + '"]');
    if (!img || img.dataset.yhlCurrent === imgUrl) return;
    img.dataset.yhlCurrent = imgUrl;
    function doSwap() {
      img.style.transition = 'opacity 0.15s ease';
      img.style.opacity    = '0';
      setTimeout(function () {
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = imgUrl; img.style.opacity = '1';
        setTimeout(function () { img.style.transition = ''; img.style.opacity = ''; }, 160);
      }, 150);
    }
    var preload = new Image(); preload.src = imgUrl;
    if (preload.complete) { doSwap(); } else { preload.onload = doSwap; }
  }

  /* ── ATC loading state: click-based, works on mobile ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__quick-add-button');
    if (!btn || btn.tagName !== 'BUTTON') return;
    btn.classList.add('is-loading');
    btn.blur();
    var fallback = setTimeout(function () { btn.classList.remove('is-loading'); }, 4000);
    function clearLoading() {
      clearTimeout(fallback);
      btn.classList.remove('is-loading');
      document.removeEventListener('cart:open',         clearLoading);
      document.removeEventListener('cart:updated',      clearLoading);
      document.removeEventListener('cart-drawer:open',  clearLoading);
      document.removeEventListener('on:cart:after-add', clearLoading);
    }
    document.addEventListener('cart:open',         clearLoading, { once: true });
    document.addEventListener('cart:updated',      clearLoading, { once: true });
    document.addEventListener('cart-drawer:open',  clearLoading, { once: true });
    document.addEventListener('on:cart:after-add', clearLoading, { once: true });
  });

  /* ── Variant dropdown change ── */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('.product-card__variant-select');
    if (!select) return;
    var pid  = select.getAttribute('data-card-variants');
    var card = select.closest('product-card');
    var opt  = select.options[select.selectedIndex];
    if (!opt) return;

    var price   = +opt.dataset.variantPrice    || 0;
    var compare = +opt.dataset.variantCompare  || 0;
    var disc    = +opt.dataset.variantDiscount || 0;
    var perday  = +opt.dataset.variantPerday   || 0;

    var inp = $q(card, '[data-variant-input="' + pid + '"]');
    if (inp) inp.value = opt.dataset.variantId;

    swapImage(card, pid, opt.dataset.variantImage || '');

    var pb = $q(card, '[data-price-block="' + pid + '"]');
    if (pb) {
      var h = '<span class="product-card__price-current">' + fmt(price) + '</span>';
      if (compare > price) h += '<span class="product-card__price-compare">' + fmt(compare) + '</span>';
      var pillStyle = perday > 0 ? '' : ' style="display:none !important"';
      h += '<span class="product-card__price-off-pill" data-price-off-pill="' + pid + '"' + pillStyle + '>' + (perday > 0 ? 'Just ' + R + perday + '/day' : '') + '</span>';
      pb.innerHTML = h;
    }

    var sb = $q(card, '[data-save-badge="' + pid + '"]');
    if (sb) {
      if (compare > price) { sb.textContent = 'SAVE ' + fmtSave(compare - price); sb.style.display = ''; }
      else sb.style.display = 'none';
    }

    var cl = $q(card, '[data-cod-line="' + pid + '"]');
    if (cl) cl.innerHTML = 'Pay <span style="color:var(--yhl-red)">' + R + Math.round(price * 5 / 100 / 100).toLocaleString('en-IN') + '</span> less online \u00B7 COD available';

    var ow = $q(card, '[data-off-wrap="' + pid + '"]');
    if (ow && !ow.dataset.noPromo) {
      var giftMin = +ow.dataset.giftMin || 0;
      var gh = disc > 0 ? '<span class="product-card__off-badge">' + disc + '% OFF</span>' : '';
      if (giftMin > 0 && price >= giftMin) {
        var tpl = ow.querySelector('.product-card__gift-badge') || document.querySelector('.product-card__gift-badge');
        gh += tpl ? tpl.outerHTML : '<span class="product-card__gift-badge"><span class="product-card__gift-text">FREE GIFT</span></span>';
      }
      ow.innerHTML = gh;
    }
  }, { passive: true });

  /* ── Mark initial variant images ── */
  document.querySelectorAll('.product-card__variant-select').forEach(function (select) {
    var opt = select.options[select.selectedIndex];
    if (!opt || !opt.dataset.variantImage) return;
    var img = $q(select.closest('product-card'), '[data-primary-image="' + select.getAttribute('data-card-variants') + '"]');
    if (img) img.dataset.yhlCurrent = opt.dataset.variantImage;
  });

  /* ── Boot ── */
  setTimeout(function() {
    if (window.YHLPincode) window.YHLPincode.detect().then(function(r) { if (r && r.pin) showEstimate(r.pin); });
  }, 400);
  preloadVariantImages();
}());
